import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { FormError } from '@change-corgi/design-system-legacy/components/forms';

import { ImageCropperUploader } from 'src/app/shared/components/imageUpload';

import type { ImageUploadContainerProps } from '../../types';

import { useImageUploadContainer } from './hooks/useImageUploaContainer';

export function ImageUploadContainer({ uploader, disabled = false, initialImage }: ImageUploadContainerProps) {
	const {
		data: { errorMessage, image, imageCrop },
		actions: { onImageChange, onImageCrop, dispatch },
	} = useImageUploadContainer({ uploader, initialImage });

	return (
		<div className="flex w-full flex-col gap-4">
			<Text variant="heading" size="x-small">
				<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.form.image_upload_label" />
			</Text>
			<ImageCropperUploader
				uploader={uploader}
				image={image}
				crop={imageCrop}
				disabled={disabled}
				onImageChange={onImageChange}
				onImageCrop={onImageCrop}
				buttonTheme="gray"
				onInitialized={(instance: Cropper) => {
					dispatch({ type: 'cropper/instance', payload: { cropper: instance } });
				}}
				buttonSize="small"
			/>
			{errorMessage && (
				<FormError size="small" role="alert" pt={4} data-testid="upload-error-message">
					<Translate value={errorMessage} />
				</FormError>
			)}
		</div>
	);
}
